const SYMBOLS_BEFORE_AMOUNT = ['$', '£'];

export function currencySymbolBefore(symbol) {
  return SYMBOLS_BEFORE_AMOUNT.includes(symbol);
}

export default class PriceFormatter {
  constructor(langCode, currency) {
    this.langCode = langCode ? langCode : 'de';
    this.currency = currency ? currency : '€';
  }

  format(price) {
    const number = Number(price).toLocaleString(this.getLocale(this.langCode), {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    if (currencySymbolBefore(this.currency)) {
      return `${this.currency}&nbsp;${number}`;
    }
    return `${number}&nbsp;${this.currency}`;
  }

  getLocale(langCode) {
    switch (langCode) {
      case 'en':
        return 'en-us';
      default:
        return 'de-de';
    }
  }
}
